<template>
  <div id="app">
    <page-header v-if="!isMobile"></page-header>
    <router-view></router-view>
    <page-footer v-if="!isMobile"></page-footer>
  </div>
</template>

<script>
import PageHeader from "@/components/Header"
import PageFooter from '@/components/Footer'
import {isMobile} from './utils/device';

export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter,
  },
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title || 'LKVAL'
    }
  },
  data() {
    return {
      isMobile: false,
    }
  },
  created() {
    this.isMobile = isMobile();
  },
}
</script>

<style>
</style>
